// hooks
import useOrchidDriveDataInView from "components/Dashboard/DoctorDashboard/hooks/useOrchidDriveDataInView";
import { useMemberDrive } from "contexts/orchid-drive";

// components
import TreeWidgetUI from "../tree-widget-ui";
// types
import type { TreeWidgetDataContainerProps } from "../..";

const TreeWidgetMemberDrive = ({
  folderPaths,
  children,
}: TreeWidgetDataContainerProps) => {
  const {
    entries,
    createDirectoryMemberDrive,
    // uploadFilePatientChart,
    // deleteEntry,
    batchEntryOps,
  } = useMemberDrive({
    memberDrive: [
      {
        directoryId: folderPaths[folderPaths.length - 1]?.directoryId || null,
        // TODO: add paging
        pages: [0],
      },
    ],
  });

  const dataInView = useOrchidDriveDataInView(entries[0].pages[0]);

  return (
    <>
      <TreeWidgetUI
        onCreateDir={(name, parentDirectoryId) =>
          createDirectoryMemberDrive({
            name,
            parentDirectoryId,
          })
        }
        dataInView={dataInView}
        batchEntryOps={batchEntryOps}
      />
      {children}
    </>
  );
};

export default TreeWidgetMemberDrive;
